<template>
  <v-card-text class="pa-0" style="height: 552px; overflow-y: auto;">
    <div class="pa-1" style="height: auto;">
      <stats :id="id"></stats>
    </div>
  </v-card-text>
</template>

<script>
import Stats from '../Stats'
export default {
  props: ['id'],
  components: {
    Stats
  }
}
</script>
